export default "__VITE_ASSET__3E1PrZKX__";